import { render, staticRenderFns } from "./PageBottomSheet.vue?vue&type=template&id=2d8ff88a"
import script from "./PageBottomSheet.vue?vue&type=script&lang=js"
export * from "./PageBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./PageBottomSheet.vue?vue&type=style&index=0&id=2d8ff88a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports